import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { ProjectDetailsActivityLogView } from '../../views/home/projectDetails/ProjectDetailsActivityLog.view';
import { ProjectDetailsAnnotationToolsView } from '../../views/home/projectDetails/ProjectDetailsAnnotationTools.view';
import { ProjectDetailsCollaboratorsView } from '../../views/home/projectDetails/ProjectDetailsCollaborators.view';
import { ProjectDetailsDatasetsView } from '../../views/home/projectDetails/ProjectDetailsDatasets.view';
import { ProjectDetailsExportDataView } from '../../views/home/projectDetails/ProjectDetailsExportData.view';
import { ProjectDetailsImagesView } from '../../views/home/projectDetails/ProjectDetailsImages.view';
import { ProjectDetailsOverviewView } from '../../views/home/projectDetails/ProjectDetailsOverview.view';
import { ProjectDetailsStatisticsView } from '../../views/home/projectDetails/ProjectDetailsStatistics.view';
import { Home } from '../config/Home';

export const ProjectDetailsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.Projects.Details.Overview.Path}>
      <ProjectDetailsOverviewView />
    </Route>
    <Route path={Home.Projects.Details.Datasets.Path}>
      <ProjectDetailsDatasetsView />
    </Route>
    <Route path={Home.Projects.Details.Images.Path}>
      <ProjectDetailsImagesView />
    </Route>
    <Route path={Home.Projects.Details.TeamMembers.Path}>
      <ProjectDetailsCollaboratorsView />
    </Route>
    <Route path={Home.Projects.Details.Statistics.Path}>
      <ProjectDetailsStatisticsView />
    </Route>
    <Route path={Home.Projects.Details.ExportData.Path}>
      <ProjectDetailsExportDataView />
    </Route>
    <Route path={Home.Projects.Details.AnnotationView.Path}>
      <ProjectDetailsAnnotationToolsView />
    </Route>
    <Route path={Home.Projects.Details.ActivityLog.Path}>
      <ProjectDetailsActivityLogView />
    </Route>
  </SwitchWithNotFound>
);
